var linky_image = /\.(png|apng|jpg|avif|jpeg|gif|webp|jfif|gifv)/gi
var linky_audio = /\.(wav|mp3|m4a|ogg)/gi
var linky_video = /\.(mp4|mpg|mpeg|webm)/gi

var link_all_formats = [
	'apng',
	'bmp',
	'avif',
	'gif',
	'jfif',
	'jpeg',
	'jpg',
	'mp3',
	'mp4',
	'mpeg',
	'mpg',
	'ogg',
	'ogv',
	'png',
	'webm',
	'webp',
]